import { Component, EventEmitter, Input, Output, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ImageCroppedEvent } from 'ngx-image-cropper';

@Component({
  selector: 'app-image-cropper',
  templateUrl: './image-cropper.component.html',
})
export class ImageCropperComponent {
  private readonly platformId = inject(PLATFORM_ID);
  readonly isBrowser = isPlatformBrowser(this.platformId);

  @Input() imageChangedEvent!: any;
  @Input() aspectRatio: number = 1;
  @Input() cropWidth!: number;
  @Input() maintainAspectRatio = true;
  @Input() showCropper = true;
  @Input() imageDimension!: string;

  @Output() confirm = new EventEmitter<{
    base64: string;
    extension: string;
    width: number;
    height: number;
    size: number;
  }>();
  @Output() closed = new EventEmitter<void>();

  constructor(private sanitizer: DomSanitizer) {}
  alignImage = 'center' as const;
  croppedImage: SafeUrl = '';
  rawImageData: string = '';
  croppedWidth: number = 0;
  croppedHeight: number = 0;
  imageBlob: Blob | null = null;

  imageCropped(event: ImageCroppedEvent) {
    this.imageBlob = event.blob || null;

    this.croppedWidth = event.width || 0;
    this.croppedHeight = event.height || 0;
    this.croppedImage = this.sanitizer.bypassSecurityTrustUrl(
      event.objectUrl || '',
    );
  }

  async confirmCrop() {
    if (!this.imageBlob) {
      console.error('No image blob available');
      return;
    }

    const extension = this.imageBlob.type.split('/')[1];
    const dataUrl = await this.blobToDataURL(this.imageBlob);

    this.confirm.emit({
      base64: dataUrl,
      extension,
      width: this.croppedWidth,
      height: this.croppedHeight,
      size: this.imageBlob.size,
    });
  }

  blobToDataURL(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  cancel() {
    this.closed.emit();
  }
}
